import { gql } from "@apollo/client"

export const GET_ALL_TOURNAMENT_ROUNDS = gql`
  query allTournamentRounds($tournamentId: Int!, $paginate: Int) {
    allTournamentRounds(
      filter: { tournamentId: $tournamentId }
      orderBy: sortOrder_ASC
      paginate: $paginate
    ) {
      id
      name
      description
      sortOrder
      urlView
      urlStanding
      tournamentId
      minutes
      statusId
      totalMatches
      totalMatchPendings
      created
    }
  }
`
